<a
  *ngIf="!xhrInProgress && user; else favoriteLoading"
  (click)="toggleFavorite()"
>
  <ion-icon
    color="dark"
    [name]="favorited ? 'heart' : 'heart-outline'"
    slot="icon-only"
  ></ion-icon>
</a>
<ng-template #favoriteLoading>
  <a *ngIf="user">
    <ion-spinner name="crescent" slot="icon-only"></ion-spinner>
  </a>
</ng-template>
